import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	name
	capacity
	photo_url
	position
	available_for
	aed
	kind
	active
	
	translations {
		${FieldsTranslation}
	}
	
	address {
		name
		postal_code
		locality
		country
		is_valid
	}
`;
